import * as React from 'react';

import classnames from 'classnames';

import {Radio} from 'shells/radio/radio';

import type {MeetingType} from 'nutshell-graphql-types';

import styles from './meeting-host-type-selection.module.css';

type Props = {
    icon: React.ReactNode;
    label: string;
    sublabel: string;
    value: MeetingType;
    isDisabled?: boolean;
};

export function HostTypeSelectRadio(props: Props) {
    const disabledStyle = classnames({
        disabled: props.isDisabled,
    });

    return (
        <div className={disabledStyle}>
            <Radio
                value={props.value}
                size={15}
                shouldTopAlignInput={true}
                shouldWidthFitContent={true}
                disabled={props.isDisabled}
            >
                <div className={styles['radio-label']}>
                    {props.icon}
                    <div>{props.label}</div>
                </div>
                <div className={styles['radio-sublabel']}>{props.sublabel}</div>
            </Radio>
        </div>
    );
}
